import { render, staticRenderFns } from "./ActivityHead.vue?vue&type=template&id=1b3ba186&"
import script from "./ActivityHead.vue?vue&type=script&lang=js&"
export * from "./ActivityHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports